import { Pipe, PipeTransform } from '@angular/core';
import { getName, registerLocale } from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import ruLocale from 'i18n-iso-countries/langs/ru.json';
import hyLocale from 'i18n-iso-countries/langs/hy.json';

registerLocale(enLocale as Parameters<typeof registerLocale>[0]);
registerLocale(ruLocale as Parameters<typeof registerLocale>[0]);
registerLocale(hyLocale as Parameters<typeof registerLocale>[0]);

@Pipe({
  name: 'countryName',
  standalone: true,
})
export class CountryNamePipe implements PipeTransform {
  transform(code: string | null | undefined, lang = 'en'): string {
    if (!code) return '';
    return getName(code, lang) ?? code;
  }
}
